import { useQueryClient } from "@tanstack/react-query";
import produce from "immer";
import { getUUID } from "@annunciate/core";
import { BOOKMARK_UPSERT } from "../queries/bookmark";
import { useMutation } from "./base";
export const useBookmarkUpsertMutation = () => {
    const client = useQueryClient();
    return useMutation(BOOKMARK_UPSERT, {
        onSuccess: async (data, result) => {
            const bookmark = data;
            const uuid = getUUID(true);
            const key = ["bookmark", uuid, { contentId: bookmark.contentId }];
            client.setQueryData(key, (old) => {
                const newItem = produce(old || [], (draft) => {
                    const idx = draft.findIndex((b) => b.id === bookmark.id);
                    if (idx > -1) {
                        draft[idx] = bookmark;
                    }
                    else {
                        draft.push(bookmark);
                    }
                });
                return newItem;
            });
            client.getQueryData(key);
        },
    }, (data) => data.result);
};
//# sourceMappingURL=useBookmarkUpsertMutation.js.map